/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Export_EmptyInputs */

const en_reports_export_empty = /** @type {(inputs: Reports_Export_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is nothing to export.`)
};

const pt_br2_reports_export_empty = /** @type {(inputs: Reports_Export_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há nada para exportar.`)
};

/**
* | output |
* | --- |
* | "There is nothing to export." |
*
* @param {Reports_Export_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_export_empty = /** @type {((inputs?: Reports_Export_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Export_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_export_empty(inputs)
	return pt_br2_reports_export_empty(inputs)
});